/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaCipherIvSpc from './AqaCipherIvSpc';
import AqaCipherKey from './AqaCipherKey';

/**
 * The AqaCipher model module.
 * @module model/AqaCipher
 * @version v0
 */
export default class AqaCipher {
  /**
   * Constructs a new <code>AqaCipher</code>.
   * @alias module:model/AqaCipher
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaCipher</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaCipher} obj Optional instance to populate.
   * @return {module:model/AqaCipher} The populated <code>AqaCipher</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaCipher();
      if (data.hasOwnProperty('key'))
        obj.key = AqaCipherKey.constructFromObject(data['key']);
      if (data.hasOwnProperty('nonce'))
        obj.nonce = ApiClient.convertToType(data['nonce'], 'Blob');
      if (data.hasOwnProperty('ivSpc'))
        obj.ivSpc = AqaCipherIvSpc.constructFromObject(data['ivSpc']);
    }
    return obj;
  }
}

/**
 * @member {module:model/AqaCipherKey} key
 */
AqaCipher.prototype.key = undefined;

/**
 * @member {Blob} nonce
 */
AqaCipher.prototype.nonce = undefined;

/**
 * @member {module:model/AqaCipherIvSpc} ivSpc
 */
AqaCipher.prototype.ivSpc = undefined;

